import { PaginationReturn } from '@common/types/service';
import {
    GetOnlineTrainingCoursesArgs,
    OnlineTrainingCourseDetail,
    OnlineTrainingCourseListItem,
} from '@onlineTraining/types/onlineTraining';
import { api } from '@services/api';

const onlineTrainingApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getOnlineTrainingCourses: builder.query<
            PaginationReturn<OnlineTrainingCourseListItem, number>,
            GetOnlineTrainingCoursesArgs
        >({
            query: ({ page = 1, page_size = 10, ...params }) => ({
                url: '/online-training/courses/',
                params: {
                    page,
                    page_size,
                    ...params,
                },
            }),
            providesTags: ['OnlineTraining'],
        }),
        getOnlineTrainingCourse: builder.query<OnlineTrainingCourseDetail, { id: number; language?: string }>({
            query: ({ id, language }) => ({
                url: `/online-training/courses/${id}/`,
                params: { language },
            }),
            providesTags: ['OnlineTraining'],
        }),
    }),
});

export const {
    useGetOnlineTrainingCourseQuery,
    useGetOnlineTrainingCoursesQuery,
    useLazyGetOnlineTrainingCoursesQuery,
} = onlineTrainingApi;
export default onlineTrainingApi;
